import dxDataGrid from 'devextreme/ui/data_grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

export const getBase64FileDataString = (mimeType?: string) => {
    if (mimeType) {
        return 'data:' + mimeType + ';base64';
    }
};

export const downloadFileFromBase64 = (documentString: string, fileName: string, mimeType: string) => {
    if (documentString && fileName && mimeType) {
        // get the base64 prefix to build the source
        // for an anchor element and simulate clicking it
        // to download the file
        const fileData = getBase64FileDataString(mimeType);
        const linkSource = `${fileData},${documentString}`;
        let downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }
};

export const openBlobAsFileInNewTab = (blob: Blob, fileName: string) => {
    const fileURL = URL.createObjectURL(blob);
    window.open(fileURL, fileName);
    setTimeout(function () {
        URL.revokeObjectURL(fileURL);
    }, 40000);
};

// Helper function to convert a base64 string to a Blob
const base64ToBlob = (base64: string, mimeType: string): Blob => {
    // using atob and Uint8Array to successfully open the html in a browser tab
    // without getting security errors (Content Security Policy (CSP) violations)
    // that we would get if we used fetch with data URL approach like EDI Config does.
    // Also tried to use target=_blank on an anchor element, but that was
    // opening as an empty tab and had to refresh the tab to display the data.
    // atob does the conversion from base64 and Uint8Array allows blob creation without using fetch
    // which satisfies displaying correctly formatted html (including special characters)
    // without CSP violation.
    const byteString = atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([uint8Array], { type: mimeType });
};

export const openHtmlFileFromBase64 = async (documentString: string, fileName: string, mimeType: string) => {
    if (documentString) {
        // 1. Create the Blob directly from the base64 string and mime type.
        const blob = base64ToBlob(documentString, mimeType);
        
        // 2. Open the Blob in a new tab.
        openBlobAsFileInNewTab(blob, fileName);
    }
};

export const downloadDocument = (documentString: string, fileName: string, mimeType: string, openInNewTab?: boolean) => {
    if (documentString) {
        if (openInNewTab === true && mimeType.indexOf("htm") > 0) {
            openHtmlFileFromBase64(documentString, fileName, mimeType);
        } else {
            downloadFileFromBase64(documentString, fileName, mimeType);
        }
    }
};

export const exportDataGridToCSV = async (worksheetName: string, fileName: string, gridRef: dxDataGrid<any, any> | undefined): Promise<boolean> => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(worksheetName);
    
    try {
        await exportDataGrid({
            component: gridRef,
            worksheet,
            });
            
        let buffer = await workbook.csv.writeBuffer();
            
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
        
        return true;
       
    } catch (error) {
        return false;
    }
    
};